import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function Envelope({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();

  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.envelope')}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="58"
      viewBox="0 0 80 58"
      fill="none"
      className={clsx(styles.brand, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80 0V58H0L0 0H80ZM4.7998 53.2666H75.2002V14.3564L40 42.5L4.7998 14.3232V53.2666ZM4.7998 4.7334V8.00195L39.999 36.1865L74.6855 8.49023L75.2002 8.04102V4.7334H4.7998Z"
        fill="inherit"
      />
    </svg>
  );
}
